import { Component, OnInit, computed, effect, inject, input, model } from '@angular/core';
import { BANK_CONFIG } from 'src/app/bank.config';
import { DIALOG_CONTROLLER } from 'src/app/BaseDialog/dialog-controller';
import { ALERT_TYPE, ERROR_MESSAGES, SUCCESS_MESSAGES } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { ContactService } from 'src/services/contact.service';
import { CustomerAccountService } from 'src/services/customer-account.service';

@Component({
  selector: 'app-add-customer-bank-account',
  templateUrl: './add-customer-bank-account.component.html',
  styleUrl: './add-customer-bank-account.component.scss',
  standalone: false
})
export class AddCustomerBankAccountComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private customerAcccountService = inject(CustomerAccountService);
  private contactService = inject(ContactService);
  private dialog = inject(DIALOG_CONTROLLER, { optional: true });

  customer = input.required<Customer>();
  lockIsContact = input<boolean>(false);
  account = model<CustomerAccount>(new CustomerAccount());
  isContactAcct = model<boolean>(true);
  isOtherBank = computed(() => {
    return !BANK_CONFIG.some(b => b.bankName === this.account().Bank);
  })
  selectedContactId = model<number>(null);
  selectedContact = computed(() => this.contactList.find(c => c.ID === this.selectedContactId()));
  contactList: Contact[] = [];

  disabledSubmit = false;

  readonly BANK_CONFIG = BANK_CONFIG;

  ngOnInit(): void {
    this.getContactList();
  }

  async getContactList() {
    this.contactList = await this.contactService.getAllCustomerContacts(this.customer().ID);
    if (this.contactList.length == 0)
      this.isContactAcct.set(false);
  }

  bankChanged(newValue: string) {
    this.account.update(acc => {
      acc.Bank = newValue !== 'Other' ? newValue : null;
      return Object.assign(new CustomerAccount(), acc);
    });
  }

  validate(): string[] {
    let errors: string[] = [];
    if (this.isContactAcct() && this.selectedContactId() == null) {
      errors.push(ERROR_MESSAGES.EMPTY_SELECTION('contact'));
    }
    return [...errors, ...this.account().validate()];
  }

  async submit() {
    this.account().ContactId = this.isContactAcct() ? this.selectedContactId() : null;
    if (this.account().HolderName == null || this.account().HolderName.trim().length === 0) {
      this.account().HolderName = this.isContactAcct() ? this.selectedContact()?.Name : this.customer().Name;
    }
    const errors = this.validate();
    if (errors.length > 0) {
      this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER);
      this.disabledSubmit = false;
    } else {
      const addedAccount = await this.customerAcccountService.getAddCompanyAccount(this.customer().ID, this.account());
      this.dialog?.close(addedAccount);
      this.sharedService.openAlert(SUCCESS_MESSAGES.ADDED(`${this.isContactAcct() ? 'guarantor' : 'customer'} bank account`), ALERT_TYPE.SUCCESS);
    }
  }

  dismiss() {
    this.dialog?.close();
  }
}
